import { createContext, useState, useEffect, useCallback, useRef } from "react";
import { isAuthenticated, clearToken } from "../utils/manageStore";
import { useNavigate, useLocation } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const logoutDuration = process.env.REACT_LOGOUT_DURATION_IN_MINUTES||60;
  const [user, setUser] = useState(() => {
    const storedValue = localStorage.getItem("user");
    return storedValue ? JSON.parse(storedValue) : null;
  });
  const [rolePermissions, setRolePermissions] = useState(() => {
    const storedPermissions = localStorage.getItem("rolePermissions");
    return storedPermissions ? JSON.parse(storedPermissions) : null;
  });
  const [accountFilterValue, setAccountFilterValue] = useState("");
  const [departmentFilterValue, setDepartmentFilterValue] = useState("");
  const [countryFilterValue, setCountryFilterValue] = useState("");
  const [yearFilterValue, setYearFilterValue] = useState("");
  const [candidateIdValue, setCandidateIdValue ] = useState("");
  const timeoutRef = useRef(null);

  const [reloadDataFunc, setReloadDataFunc] = useState(() => () => {});
  const [reloadDataRat, setReloadDataRat] = useState(() => () => {});

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      handleLogout(); // Auto-logout after 1 hour
    }, logoutDuration*60000); // 1 hour
  }, []);

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(user));
  }, [user]);

  useEffect(() => {
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    const handleActivity = () => resetTimer();

    events.forEach((event) => window.addEventListener(event, handleActivity));
    resetTimer(); // Initialize timer when context loads

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [resetTimer]);


  useEffect(() => {
    // List of main pages where you want to reset filters
    //const mainPages = ["/dashboard", "/candidate", "/job-list", "/users"]; // Add your main routes here

    // if (mainPages.includes(location.pathname)) {
    //   setAccountFilterValue("");
    //   setDepartmentFilterValue("");
    //   setCountryFilterValue("");
    //   setYearFilterValue("");
    // }
    // If you want to reset on every route change, just remove the if condition
    setAccountFilterValue("");
    setDepartmentFilterValue("");
    setCountryFilterValue("");
    setYearFilterValue("");
  }, [location.pathname]);

  const login = (userData) => {
    setUser(userData);
    resetTimer(); // Start the timer after login
  };

  const handleLogout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    console.log("User has been logged out due to inactivity.");
    setUser(null);
    setRolePermissions(null);
    localStorage.removeItem("rolePermissions");
    clearToken();
    navigate("/");
  };

  const getToken = () => {
    return isAuthenticated();
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        login,
        handleLogout,
        getToken,
        accountFilterValue,
        setAccountFilterValue,
        departmentFilterValue,
        setDepartmentFilterValue,
        countryFilterValue,
        setCountryFilterValue,
        yearFilterValue,
        setYearFilterValue,
        candidateIdValue, 
        setCandidateIdValue,
        rolePermissions, 
        setRolePermissions,
        reloadDataFunc, 
        setReloadDataFunc,
        reloadDataRat, 
        setReloadDataRat
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
